import { FC } from 'react'
import { Routes, Route } from 'react-router-dom'
import { LoginPage } from '../../pages/login'
import {
  useRedirectToLogin,
  useShowMaintenanceModal,
  useCheckAuth,
} from '../../features/users'
import { useClientUpdateNotification } from '../../features/notifications'
import { ThemeProvider } from '@mui/material/styles'
import { ToastProvider } from '../../contexts/ToastContext'
import MelphinIndexPage from './pages/index'
import { useGetTheme } from '../../shared'
import { devReportRoutes } from '../../pages/devReport/routes'
import { portalRoutes } from './pages/portal/routes'
import { guideRoutes } from '../../pages/guide/routes'

const MelphinApp: FC = () => {
  useRedirectToLogin()
  useCheckAuth()
  const theme = useGetTheme()
  const MaintenanceModal = useShowMaintenanceModal()
  const { renderNotification } = useClientUpdateNotification()

  return (
    <>
      <ThemeProvider theme={theme}>
        <ToastProvider>
          {MaintenanceModal}
          {renderNotification()}
          <Routes>
            <Route path="/" element={<MelphinIndexPage />} />
            <Route path="/login" element={<LoginPage />} />
            {/* Melphinでは全ルートが利用可能 */}
            {portalRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            {devReportRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            {guideRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </ToastProvider>
      </ThemeProvider>
    </>
  )
}

export default MelphinApp
